import CheckpointConfig from '@/features/onboarding/components/CheckpointConfigDrawer';
import OnboardingCheckpointCards from '@/features/onboarding/components/OnboardingCheckpointCards';
import OnboardingCheckpointGrid from '@/features/onboarding/components/OnboardingCheckpointGrid';
import OnboardingCheckpointSearchBar from '@/features/onboarding/components/OnboardingCheckpointSearchBar';
import OnboardingConfigurationStatusPanel from '@/features/onboarding/components/OnboardingConfigurationStatusPanel';
import OnboardingFlowHeader from '@/features/onboarding/components/OnboardingFlowHeader';
import SubjectOnboardingFlowShell from '@/features/onboarding/components/SubjectOnboardingFlowShell';

import OnboardApplicationConfigureForm from './OnboardApplicationConfigureForm';
import OnboardApplicationDetails from './OnboardApplicationDetails';
import { useOnboardApplicationController } from './useOnboardApplicationController';

const OnboardApplication = () => {
  const {
    checkpointConfigProps,
    checkpointListProps,
    checkpointSearchProps,
    configureFormProps,
    detailsProps,
    emptyStateMessage,
    hasLatestConfiguration,
    headerProps,
    isMobileViewport,
    statusProps,
  } = useOnboardApplicationController();

  return (
    <SubjectOnboardingFlowShell
      checkpointConfig={<CheckpointConfig {...checkpointConfigProps} />}
      checkpointSearch={
        checkpointSearchProps ? (
          <OnboardingCheckpointSearchBar {...checkpointSearchProps} />
        ) : null
      }
      desktopCheckpointList={
        <OnboardingCheckpointGrid {...checkpointListProps} />
      }
      emptyStateMessage={emptyStateMessage}
      hasConfiguration={hasLatestConfiguration}
      header={<OnboardingFlowHeader {...headerProps} />}
      isMobileViewport={isMobileViewport}
      mobileCheckpointList={
        <OnboardingCheckpointCards {...checkpointListProps} />
      }
      subjectDetails={<OnboardApplicationDetails {...detailsProps} />}
      subjectSelection={
        <OnboardApplicationConfigureForm {...configureFormProps} />
      }
      subjectStatus={
        statusProps ? (
          <OnboardingConfigurationStatusPanel {...statusProps} />
        ) : null
      }
    />
  );
};

export default OnboardApplication;
